export var BORDER_WIDTH = 2;
export var BORDER_COLOR = 'neutral50';
export var BORDER_COLOR_HOVER = 'primary60';
export var BORDER_COLOR_FOCUS = 'primary80';
export var BORDER_COLOR_ERROR = 'red70';
export var BORDER_COLOR_ERROR_HOVER = 'red60';
export var BORDER_COLOR_ERROR_FOCUS = 'red80';
export var BORDER_COLOR_WARNING = 'yellow70';
export var BORDER_COLOR_WARNING_HOVER = 'yellow60';
export var BORDER_COLOR_WARNING_FOCUS = 'yellow80';
export var SHADOW_COLOR = 'neutral90';
export var SHADOW_OPACITY = 0.3;
export var DIVIDER_WIDTH = 1;
export var DIVIDER_COLOR = 'neutral30';
export var ITEM_PADDING = 'S200';
export var ITEM_WITH_GROUPING_LEFT_PADDING = 'S300';
export var SCREEN_EDGE_GAP = 'S300';
export var FONT_SIZE = 'T200';
export var TEXT_COLOR = 'neutral90';
export var TEXT_COLOR_DISABLED = 'neutral70';
export var LABEL_TEXT_COLOR = 'neutral70';
export var CHEVRON_COLOR = 'primary70';
export var CHEVRON_COLOR_ERROR = 'red70';
export var CHEVRON_COLOR_WARNING = 'yellow70';
export var CHEVRON_COLOR_DISABLED = 'neutral70';
export var BACKGROUND_COLOR_DISABLED = 'neutral10';
export var HIGHLIGHT_COLOR = 'primary05';
export var HIGHLIGHT_TEXT_COLOR = 'neutral0';
export var NAVIGATION_SELECTED_COLOR = 'primary70';
export var NAVIGATION_HIGHLIGHT_COLOR = 'primary60';
export var MINIMAL_HEIGHT = 150;
export var MAX_VISIBLE_ITEMS = 10;
export var GROUP = 'option_group';
export var A11Y_GROUP_PREFIX = 'in group ';
export var GROUP_ITEM_PADDING = 24;